@if (!showNewFilterButton) {
  <div fxLayout="column" fxLayoutAlign="center center" (click)="showFilterClick()">
    <div class="box filter-display" [innerHtml]="filterDisplayText | safeHtml"></div>
    @if (showInstructions) {
      <h6>{{ 'FILTERS.FILTER-INSTRUCTIONS' | translate }}</h6>
    }
  </div>
} @else {
  <button
    [disabled]="disabled"
    class="button is-medium is-secondary"
    fxLayout="row"
    fxLayoutAlign="center center"
    (click)="newFilterClick()"
    >
    <i class="icon icon-add_plus_zoom-in"></i>
    <span>{{ 'FILTERS.ADD-FILTER' | translate }}</span>
  </button>
}

<topo-document-link-filter-dialog
  [lookupTargetSchemaFields]="lookupTargetSchemaFields"
  [isActive]="showFilterDialog"
  [datasets]="datasets"
  [filterGroup]="_filterGroup"
  (cancel)="filterCancel()"
  (filterChanged)="onFilterChanged()"
></topo-document-link-filter-dialog>
